import useOrderDetail from "hooks/order/userOrderDetail"

import { getDateByTimezone, formatPhoneNumber, formatPriceByLocale } from "utils/utils"

import OrderDetailSection from "components/presenters/commerce/order/orderHistoryDetail/OrderDetailSection"
import OrderItemBlock from "components/presenters/commerce/order/orderHistoryDetail/OrderItemBlock"
import OrderItemHeader from "components/presenters/commerce/order/OrderItemHeader"
import OrderItem from "components/presenters/commerce/order/OrderItem"
import OrderDetailInfoSection from "components/presenters/commerce/order/orderHistoryDetail/OrderDetailInfoSection"
import OrderInfoTable from "components/presenters/commerce/order/orderHistoryDetail/OrderInfoTable"
import OrderInfoRow from "components/presenters/commerce/order/orderHistoryDetail/OrderInfoRow"
import InquiryBtn from "components/presenters/commerce/order/orderHistoryDetail/InquiryBtn"

export default function OrderHistoryDetail({ orderNo }) {
  const { orderData } = useOrderDetail({ orderNo })
  console.log(orderData)
  if (!orderData) return null
  return (
    <OrderDetailSection>
      <OrderItemBlock>
        <OrderItemHeader
          orderNo={orderData.no}
          orderDate={getDateByTimezone("Asia/Seoul", new Date(orderData.create_date), ".")}
          hideBorder
        />
        {Array.isArray(orderData.order_items) &&
          orderData.order_items.map((item) => (
            <OrderItem
              key={`order_item_no_${item.no}`}
              isChallenge={item.is_challenge}
              bannerImg={item.product.banner_img}
              title={item.product.title}
              optionName={item.archived_sku.name}
              unitPrice={item.unit_price}
              quantity={item.quantity}
              challengeUnitPrice={item.challenge_unit_price}
            />
          ))}
      </OrderItemBlock>
      <OrderDetailInfoSection>
        <OrderInfoTable title="배송지 정보">
          <OrderInfoRow label="받는 사람" value={orderData.recipient} />
          <OrderInfoRow label="연락처" value={formatPhoneNumber(orderData.phone)} />
          <OrderInfoRow label="주소" value={`${orderData.address1}\n${orderData.address2}`} />
          <OrderInfoRow label="배송메모" value={orderData.shipping_action} />
        </OrderInfoTable>
        <OrderInfoTable title="결제 정보">
          <OrderInfoRow
            label="상품금액"
            value={`${formatPriceByLocale("ko", orderData.subtotal)}원`}
          />
          <OrderInfoRow
            label="배송비"
            value={`(+) ${formatPriceByLocale("ko", orderData.total_shipping)}원`}
          />
          <OrderInfoRow
            label="결제금액"
            value={`${formatPriceByLocale("ko", orderData.total_price)}원`}
          />
          <OrderInfoRow label="결제방법" value={orderData.payment_info.method} />
          <OrderInfoRow label="주문자" value={orderData.recipient} />
          <OrderInfoRow label="연락처" value={formatPhoneNumber(orderData.phone)} />
        </OrderInfoTable>
      </OrderDetailInfoSection>
      <InquiryBtn />
    </OrderDetailSection>
  )
}
